import * as React from 'react';
import { formatMoney } from 'shared/src/utils/money/money-utils';

type Props = {
  total: number;
};

export function BillableRevenueBanner({ total }: Props) {
  if (total <= 0) return null;
  return (
    <div data-testid="billable-revenue-banner" className="mt-2 flex items-center text-sm">
      <div className="bg-lime-300 rounded-l-sm px-2 py-1 font-light">$</div>
      <div className="bg-lime-100 flex-1 rounded-r-sm p-1">
        <span className="mr-1 font-medium">{formatMoney(total)}</span>
        <span>billable revenue to date</span>
      </div>
    </div>
  );
}
